import { useLocalObservable } from 'mobx-react-lite';
import { FormEvent, useEffect } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';

import { LoginError, LOGIN_FIELD_MIN_SYMBOLS } from '../../Login.constants';
import { ILoginViewProps } from '../../Login.types';

export interface ILoginEmailStepProps extends ILoginViewProps {}
interface ILoginEmailStepPresenterParams extends ILoginEmailStepProps {}

interface ILoginEmailStepFormData {
  email: string;
}

interface ILoginEmailStepPresenter {
  isFilled: boolean;
  error: LoginError | null;
  setError(error: LoginError | null): void;
  setIsFilled(isFilled: boolean): void;
  onSubmit(e: FormEvent<HTMLFormElement>): void;
}

interface IUseLoginEmailStepPresenter {
  presenter: ILoginEmailStepPresenter;
  form: UseFormReturn<ILoginEmailStepFormData>;
}

export function useLoginEmailStepPresenter(
  params: ILoginEmailStepPresenterParams
): IUseLoginEmailStepPresenter {
  const { loginPresenter } = params;

  const form = useForm<ILoginEmailStepFormData>({
    mode: 'onChange',
    defaultValues: {
      email: '',
    },
  });

  const presenter = useLocalObservable(() => ({
    isFilled: false,
    isSubmitting: false,
    error: null as LoginError | null,

    setError(error: LoginError | null): void {
      presenter.error = error;
    },

    setIsFilled(isFilled: boolean): void {
      presenter.isFilled = isFilled;
    },

    onSubmit(e: FormEvent<HTMLFormElement>): void {
      form.handleSubmit((data) => loginPresenter.onSubmitEmail(data.email.trim()))(e);
    },
  }));

  const { email } = form.watch();

  useEffect(() => {
    presenter.setIsFilled(email.length >= LOGIN_FIELD_MIN_SYMBOLS);
  }, [email]);

  useEffect(() => {
    presenter.setError(loginPresenter.error);
  }, [loginPresenter.error]);

  useEffect(() => {
    form.setValue('email', loginPresenter.email);
  }, [loginPresenter.email]);

  return { presenter, form };
}
